import { useState } from 'react';
import { ChargerLiveUpdates } from './ChargerLiveUpdates';
import { ChevronUp, ChevronDown, Activity } from 'lucide-react';

type Props = {
  chargerId?: string;
  onUpdate?: () => void;
  onConnectionChange?: (isConnected: boolean) => void;
};

export const LiveUpdatesDrawer = ({ chargerId, onUpdate, onConnectionChange }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className={`live-updates-drawer ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="drawer-handle" onClick={handleToggle}>
          <div className="handle-content">
            <Activity size={16} />
            <span>Live Updates</span>
            {isExpanded ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
          </div>
        </div>
        
        <div className="drawer-content">
          <ChargerLiveUpdates 
            chargerId={chargerId} 
            onUpdate={onUpdate}
            onConnectionChange={onConnectionChange}
          />
        </div>
      </div>

      <style>{`
        .live-updates-drawer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: var(--tg-theme-bg-color, #ffffff);
          border-top: 1px solid var(--tg-theme-hint-color, #ccc);
          transition: transform 0.3s ease-in-out;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
        }
        
        .live-updates-drawer.collapsed {
          transform: translateY(calc(100% - 48px));
        }
        
        .live-updates-drawer.expanded {
          transform: translateY(0);
        }
        
        .drawer-handle {
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: var(--tg-theme-secondary-bg-color, #f8f9fa);
          border-bottom: 1px solid var(--tg-theme-hint-color, #ccc);
          user-select: none;
          transition: background-color 0.2s ease;
        }
        
        .drawer-handle:hover {
          background: var(--tg-theme-hint-color, #e0e0e0);
        }
        
        .handle-content {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 500;
          color: var(--tg-theme-text-color, #000);
        }
        
        .drawer-content {
          max-height: 60vh;
          overflow-y: auto;
          background: var(--tg-theme-bg-color, #ffffff);
        }
        
        /* Simplified global margin for main content */
        .main-content {
          margin-bottom: 48px !important;
          transition: margin-bottom 0.3s ease-in-out;
        }
      `}</style>
    </>
  );
};